/* eslint-disable */
// Protein House tracking adapter - копие 1:1 от пакета на агенцията (ph-tracking.js, 2026-11-02).
// Единствената промяна: IIFE-то е обвито във функция, за да се пусне чак когато знаем,
// че обектът има client_gtm_id (виж clientTracking.js). Самият код си проверява host/path.
export default function installPhTracking() {
/* Protein House tracking adapter. Load once, only on the PH tenant.
 * Targets published GTM Version 2. Requires site/CMP integration and live testing.
 * CMP integration is mandatory: consentApplied() does NOT update GTM consent.
 * Call it only AFTER your CMP has applied GTM consent via its template APIs.
 * Do not pass customer contact data, dietary/health answers or free text here.
 */
(function (w) {
  'use strict';
  var h = w.location.hostname.toLowerCase();
  if (!(h === 'proteinhouse.bg' || h === 'www.proteinhouse.bg' ||
    (h === 'menu.tabl.bg' && /^\/protein-house(?:\/|$)/.test(w.location.pathname)))) return;
  if (w.PHTracking) return;
  var dl = w.dataLayer = w.dataLayer || [];
  var consent = { analytics: false, marketing: false };
  var analyticsStarted = false;
  var seen = new Set();
  var map = {
    view_item_list: 'ViewItemList', select_item: 'SelectItem', view_item: 'ViewContent',
    add_to_cart: 'AddToCart', remove_from_cart: 'RemoveFromCart', view_cart: 'ViewCart',
    begin_checkout: 'InitiateCheckout', add_shipping_info: 'AddShippingInfo',
    add_payment_info: 'AddPaymentInfo', purchase: 'Purchase', refund: 'Refund',
    view_promotion: 'ViewPromotion', select_promotion: 'SelectPromotion'
  };
  function id() { return w.crypto.randomUUID(); }
  function meta(name, eventId, params) {
    if (!consent.marketing) return;
    dl.push({ event: 'ph_meta_event', ph_meta: {
      event_name: name, event_id: eventId, params: params || {}
    }});
  }
  function copyAllowed(input, keys) {
    var result = {};
    keys.forEach(function (key) {
      if (Object.prototype.hasOwnProperty.call(input, key)) result[key] = input[key];
    });
    return result;
  }
  w.PHTracking = {
    // CMP must deny by default, persist its own choice, apply GTM consent first,
    // and call this on every page load + every change (including withdrawal).
    consentApplied: function (state) {
      var old = consent;
      consent = { analytics: state.analytics === true, marketing: state.marketing === true };
      if (consent.analytics && !old.analytics) {
        dl.push({ event: analyticsStarted ? 'ph_virtual_pageview' : 'ph_analytics_ready' });
        analyticsStarted = true;
      }
      if (consent.marketing && !old.marketing) meta('PageView', id(), {});
      // CMP must ALSO stop/revoke already-loaded vendors on withdrawal.
      // This adapter deliberately does not globally revoke shared TabL fbq.
    },
    // Call once AFTER each genuine SPA route change, URL and title updated.
    // Do not call for the initial render, checkout steps or consent banners.
    pageChanged: function () {
      if (consent.analytics) dl.push({ event: 'ph_virtual_pageview' });
      meta('PageView', id(), {});
    },
    // Purchase: eventId must come from a confirmed backend order, stable across
    // browser/CAPI/retries. Other interactions: fresh UUID per logical action.
    ecommerce: function (name, ecommerce, eventId) {
      if (!Object.prototype.hasOwnProperty.call(map, name)) throw new Error('Unsupported event');
      if (typeof eventId !== 'string' || !eventId) throw new Error('eventId is required');
      var e = copyAllowed(ecommerce, ['transaction_id','currency','value','tax','shipping',
        'coupon','payment_type','shipping_tier','item_list_id','item_list_name',
        'promotion_id','promotion_name','creative_name','creative_slot']);
      e.items = (ecommerce.items || []).map(function (item) {
        return copyAllowed(item, ['item_id','item_name','item_brand','item_category',
          'item_variant','price','quantity','discount','coupon','index','item_list_id',
          'item_list_name','affiliation','promotion_id','promotion_name','creative_name','creative_slot']);
      });
      if (!e.items.length || e.items.some(function (item) {
        return typeof item.item_id !== 'string' || !item.item_id ||
          typeof item.price !== 'number' || !Number.isFinite(item.price) || item.price < 0 ||
          !Number.isInteger(item.quantity) || item.quantity <= 0;
      })) throw new Error('Validated items with id, price and quantity are required');
      if (!/^[A-Z]{3}$/.test(e.currency || '') || typeof e.value !== 'number' ||
        !Number.isFinite(e.value) || e.value < 0) throw new Error('Invalid value/currency');
      if ((name === 'purchase' || name === 'refund') &&
        (typeof e.transaction_id !== 'string' || !e.transaction_id)) throw new Error('transaction_id is required');
      var key = name + ':' + eventId;
      if (seen.has(key)) return false;
      if (!consent.analytics && !consent.marketing) return false;
      seen.add(key);
      if (consent.analytics) {
        dl.push({ ecommerce: null });
        dl.push({ event: name, ecommerce: e });
      }
      meta(map[name], eventId, {
        content_type: 'product', content_ids: e.items.map(function (i) { return i.item_id; }),
        contents: e.items.map(function (i) { return { id: i.item_id, quantity: i.quantity, item_price: i.price }; }),
        num_items: e.items.reduce(function (n, i) { return n + i.quantity; }, 0),
        value: e.value, currency: e.currency, order_id: e.transaction_id
      });
      return true;
    }
  };
})(window);
}
